/* SPDX-License-Identifier: AGPL-3.0-or-later */

import {HttpErrorResponse} from '@angular/common/http';
import {Component, Inject} from '@angular/core';
import {FormControl, FormGroup, ValidationErrors, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TeamDto, TournamentEndpointService, TournamentUpdateTeamDto} from '@api';
import LivesAtEnum = TournamentUpdateTeamDto.LivesAtEnum;

@Component({
    selector: 'app-tournament-team-edit',
    templateUrl: './tournament-team-edit.component.html',
    styleUrl: './tournament-team-edit.component.scss',
})
export class TournamentTeamEditComponent {
    tournamentId: number | undefined;
    team: TeamDto | undefined;

    form = new FormGroup({
        name: new FormControl('', [
            Validators.minLength(3),
            Validators.maxLength(20),
            Validators.required,
            (control): ValidationErrors | null =>
                this.team?.name !== control.value ? null : {notChanged: "Team name wasn't changed."},
        ]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) data: { tournamentId: number; team: TeamDto },
        private matDialogRef: MatDialogRef<TournamentTeamEditComponent>,
        private tournamentService: TournamentEndpointService,
        private snackBar: MatSnackBar,
    ) {
        this.tournamentId = data.tournamentId;
        this.team = data.team;

        if (this.team.name) {
            this.form.controls.name.setValue(this.team.name);
        }

        this.matDialogRef.disableClose = true;
        this.matDialogRef.backdropClick().subscribe(() => matDialogRef.close(false));
    }

    updateTeam() {
        if (this.form.valid) {
            this.tournamentService
                .updateTournamentTeam(this.tournamentId!, this.team!.id!, {
                    name: this.form.controls.name.value!,
                    person1Name: 'p1',
                    person2Name: 'p2',
                    contactPhoneNumber: 'phone',
                    contactEmail: 'email',
                    livesAt: LivesAtEnum.Extern,
                })
                .subscribe({
                    next: () => this.matDialogRef.close(true),
                    error: (err: HttpErrorResponse) => {
                        const errorMessage =
                            typeof err.error === 'string' ? err.error : 'Failed to update team';

                        this.snackBar.open(errorMessage, 'Close', {
                            duration: 5000,
                        });
                    },
                });
        } else {
            console.log('Invalid form');
        }
    }
}
